// Localização: src/layouts/DashboardLayout.js (V0.2.0 - Integração MobileHeader)

import React from 'react'; 
import { Outlet } from 'react-router-dom';

// Componentes
import Sidebar from '../components/Navigation/Sidebar'; 
import MobileNav from '../components/Navigation/MobileNav.jsx';
import MobileHeader from '../components/Navigation/MobileHeader.jsx';
import HeaderGestão from '../components/Navigation/HeaderGestão.jsx';


const DashboardLayout = () => {
    
    // Sidebar agora é controlado por hover, sempre começa colapsado
    // A margem sempre será 80px (sidebar colapsado) pois expande apenas no hover
    const marginClass = 'lg:ml-[80px]';

    // Define o padding inferior e superior para o conteúdo principal
    // Ajusta para a barra mobile (pb-28 = 112px) para evitar sobreposição do MobileNav
    // e agora para o header mobile (pt-[84px])
    // Em desktop, reseta os paddings (lg:pb-6, lg:pt-0)
    const paddingClasses = 'pb-28 pt-[84px] lg:pb-6 lg:pt-0';
    
    return (
        <div className="flex min-h-screen bg-fundo-cinza-moderno w-full overflow-x-hidden">
            
            {/* 1. Sidebar (Desktop/Laptop) - Controlado por hover */}
            <Sidebar />

            {/* 💡 NOVO: Mobile Header (Mobile) */}
            <MobileHeader />

            {/* 2. Área de Conteúdo Principal */}
            <div 
                className={`flex flex-col flex-grow transition-all duration-300 ease-in-out 
                    ml-0 ${marginClass} min-w-0 w-full overflow-x-hidden
                `}
            >
                {/* 💡 Header de Gestão (Desktop) - Oculto em mobile, MobileHeader já existe */}
                {/* HeaderGestão já tem posicionamento fixo com left-[80px] para respeitar o Sidebar */}
                <div className="hidden lg:block">
                    <HeaderGestão />
                </div>
                
                {/* 3. Conteúdo da Página (Outlet) */}
                {/* 💡 Ajuste de Padding: pt-[84px] para compensar o MobileHeader fixo no topo */}
                {/* Em desktop, adiciona padding-top para compensar o HeaderGestão fixo */}
                <main className={`flex-grow ${paddingClasses} lg:pt-20 w-full min-w-0 overflow-x-hidden`}>
                    <div className="w-full min-w-0 overflow-x-hidden">
                        <Outlet />
                    </div>
                </main>
            </div>

            {/* 4. Mobile Navigation Bar (Mobile - Oculto em LG) */}
            <MobileNav />
            
        </div>
    );
};

export default DashboardLayout;